/**
 * State Mapping Layer
 *
 * This module provides a decoupled mapping between state management and other systems.
 */

import { EntityType, STATE_TYPE } from "./entities";

/**
 * Maps state types to their corresponding audio playlist names
 */
export const STATE_TO_AUDIO_MAPPING = {
	[STATE_TYPE.FIREPLACE]: "FIREPLACE",
} as const;

/**
 * Gets audio playlist name for a state type
 */
export function stateMappingPlaylistGet(type: EntityType): string {
	return STATE_TO_AUDIO_MAPPING[type as keyof typeof STATE_TO_AUDIO_MAPPING];
}
